import { render, staticRenderFns } from "./newspaperPageList.vue?vue&type=template&id=13ce9bff&scoped=true&"
import script from "./newspaperPageList.vue?vue&type=script&lang=js&"
export * from "./newspaperPageList.vue?vue&type=script&lang=js&"
import style0 from "./newspaperPageList.vue?vue&type=style&index=0&id=13ce9bff&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ce9bff",
  null
  
)

export default component.exports